import { jsxs as d, jsx as e } from "react/jsx-runtime";
const o = (l) => /* @__PURE__ */ d("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...l, children: [
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 2h6.013l13.965 19.976h-6.08L2 2Zm3.312 1.737 11.502 16.64h1.955L7.109 3.738H5.312Z", clipRule: "evenodd" }),
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "m22 2.024-7.897 8.684-.864-1.232 7.024-7.452H22Zm-11.329 12.44L3.76 22H2.022l7.846-8.698.803 1.162Z", clipRule: "evenodd" })
] });
export {
  o as default
};
//# sourceMappingURL=twitter.js.map
